const PlannerDashboard = props => {
  return (
    <h1>Planner Dashboard</h1>
  )
}

export default PlannerDashboard;